import Label from "common/components/ui/Label";
import RadioButton from "common/components/ui/RadioButton";
import {
  USER_PERMISSION_LEVELS,
  USER_PERMISSIONS_CATEGORIES,
} from "common/constants";
import { typedObjectEntries } from "common/helpers/utils";
import useAppStore from "common/hooks/useAppStore";

export default function WorkspacePermissions() {
  const workspacePermissions = useAppStore(
    (state) => state.debugOptions.workspacePermissions,
  );
  return (
    <>
      {typedObjectEntries(USER_PERMISSIONS_CATEGORIES).map(
        ([key, { label, permissionOptions }]) => (
          <>
            <span className="my-2 text-xs text-black-400">
              {label} permissions
            </span>
            <div className="flex flex-wrap gap-2">
              {permissionOptions.map(({ level }) => {
                const id = `${key}_${level}`;
                const isSelected =
                  level === "none"
                    ? !workspacePermissions.find((permission) =>
                        permission.startsWith(key),
                      )
                    : workspacePermissions.includes(
                        `${key}_${USER_PERMISSION_LEVELS[level].permissionName}`,
                      );

                return (
                  <div className="flex gap-x-1" key={id}>
                    <RadioButton
                      id={id}
                      onChange={() => {
                        const updatedPermissions = workspacePermissions.filter(
                          (permission) => !permission.startsWith(key),
                        );
                        if (level !== "none") {
                          updatedPermissions.push(
                            `${key}_${USER_PERMISSION_LEVELS[level].permissionName}`,
                          );
                        }
                        useAppStore.getState().setDebugOptions({
                          workspacePermissions: updatedPermissions,
                        });
                      }}
                      checked={isSelected}
                      size="sm"
                    />
                    <Label htmlFor={id} size="sm">
                      {USER_PERMISSION_LEVELS[level].label}
                    </Label>
                  </div>
                );
              })}
            </div>
          </>
        ),
      )}
    </>
  );
}
